import identityOverlay from 'assets/camera_placeholder/identity-overlay.png';
import identityOutlineKTP from 'assets/camera_placeholder/identity-outline-ktp.png';
import identityOutlineNPWP from 'assets/camera_placeholder/identity-outline-npwp.png';
import identityOutlineSIM from 'assets/camera_placeholder/identity-outline-sim.png';

import { IdentityFrameProps } from './types';
import { useMemo } from 'react';

const IdentityFrame = (props: IdentityFrameProps) => {
  const { docType } = props;

  const identityOutline = useMemo(() => {
    switch (docType) {
      case 'drivers_license':
        return identityOutlineSIM;
      case 'npwp':
        return identityOutlineNPWP;
      case 'ktp':
      default:
        return identityOutlineKTP;
    }
  }, [docType]);

  return (
    <svg
      width='100vw'
      height='100vh'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid slice'
    >
      <defs>
        <mask id='mask' x='0' y='0'>
          <rect fill='white' x='0' y='0' width='100vw' height='100vh' />
          <image
            className='identity-overlay'
            href={identityOverlay}
            width='90%'
            x='5%'
            y='30%'
            height='max(30vh, 212px)'
          />
        </mask>
      </defs>
      <rect
        fill='#181818B2'
        width='100vw'
        height='100vh'
        x='0'
        y='0'
        mask='url(#mask)'
        fillOpacity='100%'
      />
      <image
        className='identity-outline'
        x='5%'
        y='30%'
        href={identityOutline}
        width='90%'
        height='max(30vh, 212px)'
      />
    </svg>
  );
};

export default IdentityFrame;
